import React from 'react';
import { BaseConfig } from '../BaseConfig';
import ContinueButton from '../ui/ContinueButton';
import { UIProperties } from '../UIProperties';

import './ModalAlert.css'

const ModalAlert = (props: UIProperties<ModalAlertConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container modal-disable-select">
			<div className="modal-alert-container center-on-container">
				<img src="./assets/images/general/backgrounds/modal.png"/>
				{props.parameters.smallerTitle ? 
				(<p className="modal-alert-title modal-title-font" style={{fontSize: '16pt'}}>{props.parameters.title}</p>) : 
				(<p className="modal-alert-title title-font">{props.parameters.title}</p>)}
				<div className="modal-alert-desc-container">
					<div className="center-on-container" style={{
						width: '800px',
						position: 'absolute',
						height: '245px',
					}}>
						<p tabIndex={0} id='first-object-modal' className="modal-alert-desc-center big-description-font" style={{
							position: 'absolute',
							top: '50px',
							left: '0',
						}}>{props.parameters.text}</p>
						<ContinueButton parameters= {{
							id:'last-object-modal',
							top: '330px',
							left: '305px',
							width: '190px',	
							highlightOnHover: true,
							onClicked: props.parameters.onContinueClicked
						}}/>
					</div>
				</div>
			</div>
		</div>
	);

};

export interface ModalAlertConfig extends BaseConfig {
	title: string;
	text: string;
	smallerTitle?: boolean;
	useBigText?: boolean;
	onContinueClicked: () => void;
}

export default ModalAlert;